'use es6';

import PropTypes from 'prop-types';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import { getPreviousRepliesHtml, getPreviousRepliesPlainText } from 'conversations-message-history/common-message-format/operators/commonMessageFormatGetters';
import ContentText from '../primary-message/ContentText';
import { jsx as _jsx } from "react/jsx-runtime";
const MessageReplies = ({
  className,
  isPlainText,
  message
}) => {
  const plainTextContent = getPreviousRepliesPlainText(message);
  const richTextContent = getPreviousRepliesHtml(message);
  const contentText = isPlainText && !!plainTextContent ? plainTextContent : richTextContent;
  if (!contentText || contentText.length === 0) {
    return null;
  }
  return /*#__PURE__*/_jsx(ContentText, {
    className: className,
    contentText: contentText,
    isPlainText: isPlainText && plainTextContent,
    dataTestId: "email-message-replies",
    isShowingMessageReplies: true
  });
};
MessageReplies.displayName = 'MessageReplies';
MessageReplies.propTypes = {
  className: PropTypes.string,
  isPlainText: PropTypes.bool.isRequired,
  message: RecordPropType('CommonMessage').isRequired
};
export default MessageReplies;